var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiLineButton',{attrs:{"text":_vm.text},on:{"click":_vm.edit}})
}
var staticRenderFns = []

export { render, staticRenderFns }